<template>
  <div class="games">
    <va-card :title="$t('games.cards.title') + ' API '+ this.week">
      <div class="row mb-3">
        <div class="flex md4">
          <div class="form-group">
            <va-select
              label="Dias da Semana"
              v-model="dia"
              textBy="name"
              keyBy='id'
              no-clear
              placeholder="Selecione o dia"
              maxHeight='200px'
              :options="dias"
            />
          </div>
        </div>
        <div class="flex md8 my-auto">
          <div class="count-games">
            <p>{{ gamesSelecteds.length }} jogos</p>
          </div>
        </div>
      </div>
      <va-data-table
        :fields="fields"
        :data="games"
        :loading="loading || $apollo.queries.gamesSelecteds.loading"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="logo-home" slot-scope="props">
          <div class="d-flex justify-content-center img-logo">
            <img :src="props.rowData.teams.home.logo"/>
          </div>
        </template>
        <template slot="logo-away" slot-scope="props">
          <div class="d-flex justify-content-center img-logo">
            <img :src="props.rowData.teams.away.logo"/>
          </div>
        </template>
        <template slot="actions" slot-scope="props">
          <a
            @click='check(props.rowData.fixture.id)'
          >
            <va-checkbox
              :value='selecteds.some(g => g === props.rowData.fixture.id) || gamesSelecteds.some(g => g === props.rowData.fixture.id)'
              :disabled="
                gamesSelecteds.some(g => g === props.rowData.fixture.id) ||
                  !championships.some(c => c.id_api === props.rowData.league.id) ||
                  !clubs.some(c => c.id_api === props.rowData.teams.home.id) ||
                  !clubs.some(c => c.id_api === props.rowData.teams.away.id)
              "
            />
          </a>
        </template>
      </va-data-table>
      <va-button
        type="submit"
        :disabled="buttonSubmitDisabled"
        color="success"
        @click="salvar"
        class="my-0">
        {{ textSubmit }}
      </va-button>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'gamesAPI',
  props: {
    week: {
      required: true,
    },
  },
  methods: {
    sortFixture (a, b) {
      return a.fixture.timestamp - b.fixture.timestamp
    },
    check (itemId) {
      if (this.selecteds.some(g => g === itemId)) {
        this.selecteds = this.selecteds.filter(g => g !== itemId)
      } else {
        this.selecteds.push(itemId)
      }
    },
    salvar () {
      const moment = this.$moment
      const games = this.selecteds.map(s => {
        const fixture = this.games.filter(f => f.fixture.id === s)[0]
        return {
          fixture_id: s,
          week_id: this.week,
          championship_id: this.championships.filter(c => c.id_api === fixture.league.id)[0].id,
          club1_id: this.clubs.filter(c => c.id_api === fixture.teams.home.id)[0].id,
          club2_id: this.clubs.filter(c => c.id_api === fixture.teams.away.id)[0].id,
          datetime: moment(fixture.fixture.date).format('YYYY-MM-DD[T]HH:mm:ss'),
        }
      })
      if (games.length > 0) {
        this.loading = true
        this.$apollo
          .mutate({
            mutation: gql`
                mutation MyMutation($objects: [game_insert_input!] = []) {
                  insert_game(objects: $objects) {
                    affected_rows
                  }
                }
                `,
            variables: {
              objects: games,
            },
          }).then(data => {
            if (Object.keys(this.$apollo.queries).includes('gamesSelecteds')) {
              this.$apollo.queries.gamesSelecteds.refetch()
            }
            this.loading = false
            this.selecteds = []
          }).catch(e => {
            this.loading = false
          })
      }
    },
  },
  created () {
    const moment = this.$moment
    let data
    for (let i = 1; i <= 7; i++) {
      data = moment().day(i)
      this.dias.push({
        id: i,
        date: data.toDate(),
        name: data.format('DD/MM/YYYY'),
        value: data.format('YYYY-MM-DD'),
      })
    }
    this.dia = this.dias[0]
  },
  data () {
    return {
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
      dia: '',
      dias: [],
      games: [],
      gamesSelecteds: [],
      selecteds: [],
      championships: [],
      clubs: [],
      loading: false,
    }
  },
  apollo: {
    gamesSelecteds: {
      query: gql`
      query MyQuery($week: Int) {
        gamesSelecteds: game(where: {week_id: {_eq: $week}, fixture_id: {_is_null: false}}) {
          fixture_id
        }
        championships: championship(where: {id_api: {_is_null: false}}) {
          id
          id_api
        }
        clubs: club(where: {id_api: {_is_null: false}}) {
          id
          id_api
        }
      }
      `,
      variables () {
        return {
          week: this.week,
        }
      },
      result ({ data, loading }) {
        if (!loading) {
          this.gamesSelecteds = data.gamesSelecteds.map((e) => e.fixture_id)
          this.championships = data.championships
          this.clubs = data.clubs
        }
      },
    },
  },
  watch: {
    dia (value) {
      this.loading = true
      this.$axios.get(
        `${this.$store.getters['environment/apiFront']}/fixtures/date/?date=${value.value}`,
      ).then((response) => {
        this.games = []
        if (response.data.length > 0) {
          for (const ind in response.data) {
            const jogos = response.data[ind].fixtures.sort(this.sortFixture)
            for (const jogo in jogos) {
              this.games.push(jogos[jogo])
            }
          }
          this.loading = false
        } else {
          this.loading = false
        }
      })
        .catch((_) => {
          this.games = []
          this.loading = false
        })
    },
  },
  computed: {
    fields () {
      const clubs = this.clubs
      const championships = this.championships
      const moment = this.$moment
      return [
        {
          name: 'fixture',
          title: this.$t('tables.id'),
          width: '50px',
          callback (value) {
            return value.id
          },
        },
        {
          name: 'teams',
          title: 'Clube 1',
          callback (value) {
            const sit = !clubs.some(c => c.id_api === value.home.id) ? ' - Não Cadastrado' : ''
            return `${value.home.id} - ${value.home.name}${sit}`
          },
        },
        {
          name: '__slot:logo-home',
          title: 'Clube 1',
        },
        {
          name: '__slot:logo-away',
          title: 'Clube 2',
        },
        {
          name: 'teams',
          title: 'Clube 2',
          callback (value) {
            const sit = !clubs.some(c => c.id_api === value.away.id) ? ' - Não Cadastrado' : ''
            return `${value.away.id} - ${value.away.name}${sit}`
          },
        },
        {
          name: 'league',
          title: 'Campeonato',
          callback (value) {
            const sit = !championships.some(c => c.id_api === value.id) ? ' - Não Cadastrado' : ''
            return `${value.id} - ${value.name}${sit}`
          },
        },
        {
          name: 'fixture',
          title: this.$t('games.headings.datetime'),
          callback (value) {
            return moment(value.date).format('DD/MM/YYYY [as] HH:mm:ss')
          },
        }, {
          name: '__slot:actions',
          width: '100px',
          title: this.$t('tables.actions'),
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.img-logo img {
  width: 2rem;
}

.count-games p {
  font-size: 1.15rem;
  font-weight: bold;
}
</style>

<style lang="scss">
.text-center {
  text-align: center;
}
</style>
